import styled from 'styled-components';

export const SlideTitle = styled.h3`
  font-size: 16px;
  font-weight: 700;
  margin: 15px 0 0;
  line-height: 20px;
  text-align: center;
`;

export const DurationBadge = styled.span`
  right: 10px;
  bottom: 5px;
  color: #fff;
  z-index: 151;
  font-size: 16px;
  font-weight: bold;
  position: absolute;
`;
